var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('ol',_vm._l((_vm.tooltipContentList),function(ref,index){
if ( ref === void 0 ) ref = {};
var text = ref.text;
var icon = ref.icon;
return _c('li',{key:index},[_vm._v(" "+_vm._s(text)+" "),(icon)?_c('v-icon',{attrs:{"small":"","color":"#fff"}},[_vm._v(" "+_vm._s(icon)+" ")]):_vm._e()],1)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-1 white--text text-center"},[_vm._v(" There are no custom views yet. "),_c('br'),_vm._v(" To create a custom view: ")])}]

export { render, staticRenderFns }